import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './how-to-guide.component.scss';
import * as $ from 'jquery';
var HowToGuide = /** @class */ (function (_super) {
    tslib_1.__extends(HowToGuide, _super);
    function HowToGuide(element) {
        return _super.call(this, element) || this;
    }
    HowToGuide.prototype.init = function () {
        var _this = this;
        this.slides = Array.from(this.element.querySelectorAll('.swiper-slide	'));
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderPrev = this.element.querySelector('.pagination__nav--prev');
        this.sliderPrevEnd = this.element.querySelector('.pagination__nav--prev-end');
        this.sliderNext = this.element.querySelector('.pagination__nav--next');
        this.sliderNextEnd = this.element.querySelector('.pagination__nav--next-end');
        this.sliderButtons = Array.from(this.element.querySelectorAll('.campaign-components__button'));
        this.windowWidth = document.documentElement.clientWidth;
        this.breakpoints = {};
        this.sliderConfig = {
            effect: 'fade',
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                clickable: true,
                bulletActiveClass: 'pagination__item--active',
                bulletClass: 'pagination__item',
                renderBullet: function (index, className) {
                    if (index < 3) {
                        return '<li class="' + className + '" data-pagination-index="' + index + '">' + (index + 1) + '</span>';
                    }
                    else {
                        return '<li class="' + className + ' d-none" data-pagination-index="' + index + '">' + (index + 1) + '</span>';
                    }
                }
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        this.sliderComponent = new Swiper(this.sliderContainer, this.sliderConfig);
        this.sliderComponent.on('slideChange', function (event) {
            var index = _this.sliderComponent.realIndex;
            _this.recreatePagination(index);
        });
    };
    HowToGuide.prototype.bindEvents = function () {
        var _this = this;
        $('.how-to-guide').on('click touch', '.pagination__nav--prev-end', function (event) {
            _this.sliderComponent.slideTo(0, true);
        });
        $('.how-to-guide').on('click touch', '.pagination__nav--next-end', function (event) {
            _this.sliderComponent.slideTo((_this.slides.length - 1), true);
        });
    };
    HowToGuide.prototype.recreatePagination = function (index) {
        if (index === void 0) { index = 0; }
        var slides = this.slides.length;
        // arrows
        if (index === 0) {
            this.sliderPrev.classList.add('pagination__nav--disabled');
            this.sliderPrevEnd.classList.add('pagination__nav--disabled');
            this.sliderNext.classList.remove('pagination__nav--disabled');
            this.sliderNextEnd.classList.remove('pagination__nav--disabled');
        }
        else if (index === (slides - 1)) {
            this.sliderPrev.classList.remove('pagination__nav--disabled');
            this.sliderPrevEnd.classList.remove('pagination__nav--disabled');
            this.sliderNext.classList.add('pagination__nav--disabled');
            this.sliderNextEnd.classList.add('pagination__nav--disabled');
        }
        else {
            this.sliderPrev.classList.remove('pagination__nav--disabled');
            this.sliderPrevEnd.classList.remove('pagination__nav--disabled');
            this.sliderNext.classList.remove('pagination__nav--disabled');
            this.sliderNextEnd.classList.remove('pagination__nav--disabled');
        }
        // buttons
        var buttons = Array.from(this.element.querySelectorAll('.pagination__item'));
        buttons.forEach(function (button) {
            var buttonIndex = button.getAttribute('data-pagination-index');
            var buttonIndexNumber = parseInt(buttonIndex);
            if (index === 0) {
                if (buttonIndexNumber === 0 || buttonIndexNumber === 1 || buttonIndexNumber === 2) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
            else if (index === (slides - 1)) {
                if (buttonIndexNumber === (slides - 1) || buttonIndexNumber === (slides - 2) || buttonIndexNumber === (slides - 3)) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
            else {
                if (buttonIndexNumber === index || buttonIndexNumber === (index - 1) || buttonIndexNumber === (index + 1)) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
        });
    };
    return HowToGuide;
}(Base));
export { HowToGuide };



//////////////////
// WEBPACK FOOTER
// ./components/how-to-guide/how-to-guide.component.ts
// module id = 361
// module chunks = 0